import { css } from 'emotion';
import React from 'react';

import { Button } from '../../../../../components/Button';
import { ButtonGroup } from '../../../../../components/ButtonGroup';
import { Caption } from '../../../../../components/Caption';
import { Card } from '../../../../../components/Card';
import { Modal } from '../../../../../components/Modal';
import { ExternalSites } from '../../../../../constants/ExternalSites';
import { gutter } from '../../../../../helpers/Style';

type Props = {
  visible: boolean;
  onClose: () => void;
};

/**
 * 日本語以外のブラウザで予約画面を開いた利用者に、英語ページへの導線を案内するモーダル。
 */
export const EnglishSiteGuideModal = ({ visible, onClose }: Props) => {
  const openEnglishSite = () => {
    onClose();
    // ポップアップがブロックされた場合は同じタブで遷移させる
    const opened = window.open(ExternalSites.EnglishLandingPage, '_blank', 'noopener,noreferrer');
    if (!opened) {
      window.location.href = ExternalSites.EnglishLandingPage;
    }
  };

  return (
    <Modal visible={visible} onClick={() => onClose()}>
      <Card>
        <Caption type="header">English information available</Caption>
        <div className={bodyStyle}>
          This booking site is available in Japanese only. For information in English about CLINIC TEN SHIBUYA and
          DENTAL CLINIC TEN SHIBUYA, please visit our English page.
        </div>
        <ButtonGroup gutter={10}>
          <Button block onClick={openEnglishSite}>
            View the English page
          </Button>
          <Button block ghost onClick={() => onClose()}>
            Continue in Japanese
          </Button>
        </ButtonGroup>
      </Card>
    </Modal>
  );
};

const bodyStyle = css`
  margin: ${gutter(2)} 0;
`;
